{
  "buttons": {
    "companies": "Entreprises",
    "contacts": "Contacts",
    "activities": "Activités"
  },
  "import_components": {
    "imported_file_name": "Nom du fichier importé",
    "created_by": "Créé par",
    "created_at": "Créé le",
    "progress": "Progrès",
    "error_importing_data": "Erreur lors de l'importation des données.",
    "loading": "...",
    "import_in_progress": "L'importation est en cours, revenez dans quelques minutes."
  }
}
